import { createTheme } from "@mui/material/styles";
import system from "./system";
import components from "./components";
import backgroundStyles from "./backgroundStyles";

const theme = createTheme({
  system,
  components,
  backgroundStyles,
  typography: {
    fontFamily: system.fonts.body,
    allVariants: { color: system.colors.text.primary },
  },
});

export default theme;
